export default __webpack_public_path__ + "static/media/enghien31.53719fee.jpg";